module.exports = __webpack_public_path__ + "static/media/service_icon_map.601d6345.svg";